<template>
    <div>
        <div
            v-if="trip"
            class="float-container--bottom card card-floating driver-trip-card"
            :class="{
                'card--reserva': trip.es_con_reserva,
                'driver-trip-card--compact': isCompact,
                'driver-trip-card--expanded': isCollapsible && expanded
            }"
        >
            <button v-if="isCollapsible" type="button" @click="onToggleExpanded" class="expand-button">
                <svg-item :size="30" :icon="expanded ? 'chevron-up' : 'chevron-down'" :color="'--main-color'"></svg-item>
            </button>
            <div v-if="trip.es_con_reserva && trip.fecha_hora_reserva" class="trip-reserva-badge">
                <svg-item :size="20" :icon="'calendar'" :color="'--main-color'"></svg-item>
                <strong v-lang.viajeReservado>Viaje reservado</strong>
                <span class="trip-reserva-datetime">{{ formatFechaHoraReserva(trip.fecha_hora_reserva) }}</span>
            </div>
            <div class="row">
                <div :class=" this.settings.modulo_foto_pasajero ? 'col-xs-17' : ''">
                    <div class="trip-address-row" :class="this.settings.modulo_foto_pasajero ? 'trip-address-row-photo' : '' ">
                        <span class="trip-address">
                            <svg-item :size="24" :icon="'gps'" :color="'--card-origin-title'"></svg-item>
                            <div
                                class="trip-address-element trip-address-text"
                                :class="{
                                    'with-indication': (trip.frontState === TRIP_STATE.ACCEPTED && (settings.mostrar_googlemaps_link || settings.mostrar_waze_link)),
                                    'address-expanded': originAddressExpanded
                                }"
                                @click="onToggleOriginAddress"
                            >
                                <span>{{ originAddress }}</span>
                            </div>
                            <div>
                            <button class="navigation-icon"
                                v-if="trip.frontState === TRIP_STATE.ACCEPTED && settings.mostrar_googlemaps_link"
                                @click="onOpenInMap(false, true, $event)">
                                <svg-item :size="30" :icon="'googlemaps'"></svg-item>
                            </button>
                            <button class="navigation-icon"
                                v-if="trip.frontState === TRIP_STATE.ACCEPTED && settings.mostrar_waze_link"
                                @click="onOpenInMap(false, false, $event)">
                                <svg-item :size="30" :icon="'waze'"></svg-item>
                            </button>
                            </div>
                        </span>
                    </div>
                    <div class="trip-destination-row "  v-if="destinyVisible" :class="this.settings.modulo_foto_pasajero ? 'trip-destination-row-photo' : '' ">
                        <svg-item :size="24" :icon="'lugar'" :color="'--card-destination-title'"></svg-item>
                        <span
                            class="trip-address-element trip-address-text"
                            :class="{ 'address-expanded': destinationAddressExpanded }"
                            @click="onToggleDestinationAddress"
                        >{{ trip.dest_nombre }}</span>
                    </div>
                    <div v-show="showDetails">
                        <div v-if="trip.viaje_afuera > 0"  class="text-alert">
                            <strong v-lang.viajeAfuera>Viaje afuera</strong>
                        </div>
                        <div v-if="trip.pasajero" class="passenger-row">
                            <div>
                                <span v-lang.pasajerx>Pasajero/a</span>
                                <span v-if="settings.modulo_tipo_servicios && trip.tipo_servicio">
                                    <strong> / {{ $translateFromText(trip.tipo_servicio.name) }}</strong>
                                </span>
                            </div>
                            <div class="trip-stars">
                                <span class="text-strong">{{ trip.pasajero.nombre + ' ' + trip.pasajero.apellido }} </span>
                                <span v-if="trip.pasajero.calificacion && trip.pasajero.calificacion.total > 0">
                                    ({{ (trip.pasajero.calificacion.cancelados / trip.pasajero.calificacion.total * 100).toFixed(0) }}
                                    {{translate('viajesConcretados')}})
                                </span>
                                <span v-lang.usuarioNuevo v-else>(usuario nuevo)</span>
                                <div class="trip-address-element" v-if="settings.modulo_calificacion_general_pasajero">
                                    <svg-item v-for="value in passengerStars" :key="value" :size="14" :icon="'star'"
                                        :color="value ? '--star-filled-background' : '--star-empty-background'"></svg-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-7 passenger-img" v-if="trip.chofer && this.settings.modulo_foto_pasajero">
                    <img v-imgSrc="profilePic" class="passenger-profile-photo" />
                </div>
            </div>
            <div v-show="showDetails">
                <div v-if="settings.modulo_pasajero_pago_electronico && trip.pago_electronico" class="passenger-row">
                    <strong><div v-lang.metodoPago>Método de pago:</div></strong>
                    <span>
                        <svg-item v-if="!requestingAdress" :size="24" :icon="'credit-card'" :color="'--alert-color'"></svg-item>
                        <span class="text-alert" v-lang:pagoElectronico>Pago electrónico</span>
                    </span>
                </div>
                <div v-if="settings.modulos_pagos_en_la_app && trip.payment_method_id > 0" class="passenger-row">
                    <span v-if="trip.payment_method_id > 1">
                        <svg-item :size="24" :icon="'credit-card'" :color="'--alert-color'"></svg-item>
                        <span class="text-alert" v-lang.pagoElectronico>Pago electrónico</span>
                    </span>
                    <span v-else>
                        <svg-item :size="24" :icon="'money'" :color="'--alert-color'"></svg-item>
                        <span class="text-alert" v-lang.efectivo>Efectivo</span>
                    </span>
                </div>
                <div v-if="trip.ida_vuelta" class="passenger-row">
                    <svg-item :size="20" :icon="'repeat'" :color="'--main-color'"></svg-item>
                    <strong v-lang.deIdaVuelta>De ida y vuelta</strong>
                </div>
                <div v-if="trip.mascotas > 0 || trip.silla_ruedas > 0 || trip.maletas > 0" class="passenger-row">
                    <span v-lang.lleva>Lleva:</span>
                    <span v-if="trip.mascotas > 0" class="">
                        <strong v-lang.mascotas>Mascotas</strong>
                    </span>
                    <span v-if="trip.maletas > 0" class="">
                        &nbsp;
                        &nbsp;
                        <strong v-lang.maletas>Maletas</strong>
                    </span>
                    <span v-if="trip.silla_ruedas > 0" class="">
                        &nbsp;
                        &nbsp;
                        <strong v-lang.silla_ruedas>Silla de ruedas</strong>
                    </span>
                </div>
                <div v-if="trip.comentario" class="passenger-row">
                    <div><strong v-lang.comentario>Comentario:</strong> {{ trip.comentario }}</div>
                </div>
                <div class="row">
                    <slot></slot>
                </div>
            </div>
            <div v-if="isCompact && $slots.compact" class="driver-trip-card-compact-footer">
                <slot name="compact"></slot>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { TRIP_STATE } from '@/store/mutation-types';
import browser from '@/cordova/InAppBrowser';
let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'driverTripCard',
    props: [
        'trip'
    ],
    data () {
        return {
            profilePic: null,
            expanded: false,
            originAddressExpanded: false,
            destinationAddressExpanded: false
        };
    },
    computed: {
        ...mapGetters({
            settings: 'company/config'
        }),
        isCollapsible () {
            return this.trip &&
                (this.trip.frontState === TRIP_STATE.ACCEPTED ||
                this.trip.frontState === TRIP_STATE.ARRIVED_TO_ORIGIN);
        },
        isCompact () {
            return this.isCollapsible && !this.expanded;
        },
        showDetails () {
            return !this.isCollapsible || this.expanded;
        },
        originAddress () {
            if (!this.trip) return '';
            let address = this.trip.calle || '';
            if (this.trip.altura >= 0) {
                address += ' ' + this.trip.altura;
            }
            return address.trim();
        },
        destinyVisible () {
            console.log('destinyVisible', this.trip.dest_nombre, this.trip.chofer_id, this.settings.modulo_destino_viaje, this.settings.no_mostrar_destino_al_aceptar, this.trip.frontState);
            if (this.trip.dest_nombre) {
                if (!this.trip.chofer_id) {
                    return this.settings.modulo_destino_viaje && !this.settings.no_mostrar_destino_al_aceptar;
                } else {
                    if (this.trip.frontState === TRIP_STATE.ACCEPTED || this.trip.frontState === TRIP_STATE.ARRIVED_TO_ORIGIN) {
                        return this.settings.modulo_destino_viaje && !this.settings.no_mostrar_destino_hasta_arrancar;
                    }
                    return this.settings.modulo_destino_viaje;
                }
            } else {
                return false;
            }
        },
        passengerStars () {
            if (this.trip && this.trip.pasajero) {
                let stars = [];
                for (let i = 0; i < this.trip.pasajero.calificacion_pasajero; i++) {
                    stars.push(true);
                }
                for (let i = 5; i > this.trip.pasajero.calificacion_pasajero; i--) {
                    stars.push(false);
                }
                return stars;
            } else {
                return [];
            }
        }
    },
    mounted () {
        this.language = this.$getLang();
        console.log('aca', this.trip);
        this.profilePic = this.trip.pasajero.photo ? this.$profile(this.trip.pasajero.photo) : defaultProfilePic;
    },
    watch: {
        'trip.id' () {
            this.expanded = false;
            this.originAddressExpanded = false;
            this.destinationAddressExpanded = false;
        }
    },
    updated () {
    },
    methods: {
        ...mapActions({
        }),
        onToggleExpanded () {
            this.expanded = !this.expanded;
        },
        onToggleOriginAddress () {
            this.originAddressExpanded = !this.originAddressExpanded;
        },
        onToggleDestinationAddress () {
            this.destinationAddressExpanded = !this.destinationAddressExpanded;
        },
        onOpenInMap (isDestination, inGoogleMaps) {
            browser.openInMap(this.trip, isDestination, inGoogleMaps);
        },
        translate (key) {
            return this.$lang ? this.$lang(key) : key;
        },
        formatFechaHoraReserva (fechaHora) {
            if (!fechaHora) return '';
            const d = new Date(fechaHora);
            if (isNaN(d.getTime())) return fechaHora;
            return d.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
        }
    }
};
</script>

<style scoped>
    .driver-trip-card {
        transition: padding .2s ease, font-size .2s ease;
    }
    .driver-trip-card--compact {
        padding: .55em .75em;
        font-size: .9em;
    }
    .driver-trip-card--compact .trip-address-row,
    .driver-trip-card--compact .trip-destination-row {
        margin-bottom: .35em;
        padding: 0;
    }
    .driver-trip-card--compact .trip-reserva-badge {
        margin-right: 2.3em;
        padding: .35rem .5rem;
        font-size: .85em;
    }
    .driver-trip-card-compact-footer {
        margin-top: .4em;
    }
    .driver-trip-card--expanded {
        padding-top: 2.4em;
    }
    .expand-button {
        background: transparent;
        position: absolute;
        right: 5px;
        top: 5px;
        border: 0;
        z-index: 10;
        padding: 0;
    }
    .trip-address-text {
        cursor: pointer;
        flex: 1;
        min-width: 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-height: 1.25;
        overflow-wrap: break-word;
        word-break: break-word;
    }
    .trip-address-text.address-expanded {
        display: block;
        -webkit-line-clamp: unset;
    }
    .trip-reserva-badge {
        display: flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.5rem 0.75rem;
        background: var(--main-color, #1976d2);
        color: #fff;
        border-radius: 4px;
        margin: 0 0 0.5rem 0;
        font-size: 0.95em;
    }
    .trip-reserva-badge .trip-reserva-datetime {
        opacity: 0.95;
        font-size: 0.9em;
    }
    .card--reserva {
        border-left: 4px solid var(--main-color, #1976d2);
    }
    .text-alert {
        vertical-align: -3px;
        font-size: 1.3em;
    }
    .trip-address-row,
    .trip-destination-row {
        padding: 2px 4px;
        display: block;
        font-weight: bold;
    }
    .trip-address-row {
        color: var(--card-origin-title);
        font-size: 1.2em;
        font-weight: 400;
    }
    .trip-destination-row {
        color: var(--card-destination-title);
        display: flex;
        align-items: flex-start;
        gap: .25rem;
    }
    .trip-destination {
        font-size: 1.1em;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/driver/DriverTripCard.vue